export default "__VITE_ASSET__B22bASCk__"